import { render, staticRenderFns } from "./PaymentsConfiguration.vue?vue&type=template&id=0d7f9122"
import script from "./PaymentsConfiguration.vue?vue&type=script&lang=js"
export * from "./PaymentsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports